import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT }                                        from '@angular/common';


@Injectable({ providedIn: 'root' })
export class LayoutDescomplicaService {

  private readonly document: Document;
  private readonly cloudfront: string;

  private renderer: Renderer2;

  public iframeJs: HTMLScriptElement;
  public iframeCss: HTMLStyleElement;

  constructor(
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private _document: any
  ) {
    this.renderer   = this.rendererFactory.createRenderer(null, null);
    this.document   = this._document as Document;
    this.cloudfront = 'https://d9q5ms8uemqzm.cloudfront.net';
  }

  // set some empty functions and add them to the window object,
  // coping the signatures of the old platform to avoid errors.
  private static setNoopFunctions() {

    const Red1000Utils: { [ key: string ]: VoidFunction } = {
      initCheck: () => { }
    };

    // noinspection JSUnusedGlobalSymbols
    const EdicaoRedacaoPerception = {
      salvaRedacao: (_boolean: any, _callback: any) => { }
    };

    // noinspection JSUnusedGlobalSymbols
    const TexugoAjax = {
      doGet: (_path: any, _options: { callback: (_e: any) => {} }) => { }
    };

    if (window) window[ '$' ] = { Red1000Utils, EdicaoRedacaoPerception, TexugoAjax };
  }

  private get hasDescomplicaJs(): boolean { return !!( this.document.getElementById('descomplica-js') ); }

  private get hasDescomplicaCss(): boolean { return !!( this.document.getElementById('descomplica-css') ); }

  private addDescomplicaJs() {
    if (this.hasDescomplicaJs) return;

    // noinspection SpellCheckingInspection
    localStorage.setItem('dframe-service', 'red1000');

    this.iframeJs = this.renderer.createElement('script');

    this.iframeJs.setAttribute('id', 'descomplica-js');
    // noinspection SpellCheckingInspection
    this.iframeJs.setAttribute('src', `${ this.cloudfront }/latest/dframe-loader.js?dframe_s=red1000`);

    this.renderer.appendChild(this.document.body, this.iframeJs);
  }

  private addDescomplicaCss() {
    if (this.hasDescomplicaCss) return;

    this.iframeCss = this.renderer.createElement('link');

    this.iframeCss.setAttribute('id', 'stylesheet');
    this.iframeCss.setAttribute('rel', 'descomplica-css');
    this.iframeCss.setAttribute('type', 'text/css');
    this.iframeCss.setAttribute('href', `${ this.cloudfront }/1.5.5/red1000.css`);

    this.renderer.appendChild(this.document.body, this.iframeCss);
  }

  public setupDescomplica() {
    LayoutDescomplicaService.setNoopFunctions();

    this.addDescomplicaJs();
    this.addDescomplicaCss();
  }

  public removeDescomplica() {
    if (this.hasDescomplicaJs) this.renderer.removeChild(this.document.body, this.iframeJs);
    if (this.hasDescomplicaCss) this.renderer.removeChild(this.document.body, this.iframeCss);
  }
}
